import { render } from "./VehicleHistory.vue?vue&type=template&id=7d63d382"
import script from "./VehicleHistory.vue?vue&type=script&lang=js"
export * from "./VehicleHistory.vue?vue&type=script&lang=js"

import "./VehicleHistory.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__